<template>
  <div
    class="flex min-h-screen bg-slate-50 dark:bg-dark-bg font-sans selection:bg-primary selection:text-white transition-colors duration-300 text-slate-900 dark:text-white"
  >
    <!-- Mobile overlay: tap outside to close sidebar -->
    <transition name="fade-overlay">
      <div
        v-if="sidebarOpen"
        class="fixed inset-0 bg-black/50 z-40 lg:hidden"
        @click="sidebarOpen = false"
      ></div>
    </transition>

    <Sidebar v-model:isOpen="sidebarOpen" />

    <div class="flex-1 flex flex-col h-screen overflow-hidden min-w-0">
      <Navbar @toggle-sidebar="sidebarOpen = !sidebarOpen" />
      <main
        class="flex-1 overflow-y-auto custom-scrollbar relative bg-slate-50 dark:bg-dark-bg"
      >
        <div
          class="hidden dark:block absolute top-0 right-0 w-[500px] h-[500px] bg-primary opacity-[0.03] blur-[120px] pointer-events-none"
        ></div>
        <div class="p-4 md:p-8 relative z-10">
          <slot></slot>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from "./Sidebar.vue";
import Navbar from "./Navbar.vue";

export default {
  name: "MainLayout",
  components: { Sidebar, Navbar },
  data() {
    return {
      sidebarOpen: false,
    };
  },
};
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #e2e8f0;
  border-radius: 20px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #cbd5e1;
}

.dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #1e2330;
}
.dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #2a2f3e;
}

.fade-overlay-enter-active,
.fade-overlay-leave-active {
  transition: opacity 0.3s ease;
}
.fade-overlay-enter-from,
.fade-overlay-leave-to {
  opacity: 0;
}
</style>
